// extracted by mini-css-extract-plugin
module.exports = {"box":"bq_dH","input":"bq_cV","inputPrimary":"bq_dJ bq_cV","formFeedback":"bq_b2","button":"bq_cQ","check":"bq_dK","feedbackContainer":"bq_bS"};